module.exports = __webpack_public_path__ + "img/services-05.e567f401.jpg";